import { render, staticRenderFns } from "./SocialsPreviewModal.vue?vue&type=template&id=3da19ce8&scoped=true"
import script from "./SocialsPreviewModal.vue?vue&type=script&lang=js"
export * from "./SocialsPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./SocialsPreviewModal.vue?vue&type=style&index=0&id=3da19ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da19ce8",
  null
  
)

export default component.exports